import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';
import { clearThumbnailCache } from '@air/utils-clips';

/**
 * This function returns the image src of the version.
 *
 * @param version - The version to get the image src for
 * @returns The image src of the version
 */
export const getVersionSrc = (version: Clip | PublicClip) => {
  return clearThumbnailCache({
    clipExt: version.ext,
    clipStatus: version.status,
    imageSrc: version.assets.image,
    clipUpdatedAt: version.updatedAt,
  });
};
